export const DONE_STATUSES = ['dispatched', 'completed'];
export const SPLITTABLE_STATUSES = ['draft', 'pending', 'not_started', 'in_progress'];

export const fmtQty = (n) => {
  const v = Number(n) || 0;
  return (Number.isInteger(v) ? v : Number(v.toFixed(2))).toLocaleString('en-IE');
};

// dispatch_date is stored as dd/MM/yyyy or yyyy-MM-dd
export const showDate = (str) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(str || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (str || '—');
};

export const partsSent = (parts = []) => parts.filter((p) => DONE_STATUSES.includes(p.status)).length;

const num = (v) => parseFloat(v) || 0;
const r3 = (v) => Math.round(v * 1000) / 1000;

// Same matching and measures as the backend (services/phased_dispatch.py)
export const lineKey = (l) => [l.product_id || '', l.cobranding_id || '', (l.supplier_product_code || '').trim()].join('|');
export const lineMeasures = (l) => (l.out_of_stock ? [0, 0, 0] : [
  num(l.quantity), num(l.cases_override || l.cases || l.calculated_cases), num(l.weight_override || l.total_weight || l.estimated_weight),
]);
const addM = (a, b) => [a[0] + b[0], a[1] + b[1], a[2] + b[2]];
const subM = (a, b) => a.map((v, i) => Math.max(0, r3(v - b[i])));

// Units → cases / kg from the formula when a value was never stored
const fill = ([u, c, k], { upc, wpu }) => [u, c > 0 || !(upc > 0) ? c : u / upc, k > 0 || !(wpu > 0) ? k : u * wpu];

export const nextOpenPart = (summary, selfId) => {
  const self = summary?.parts?.find((p) => p.id === selfId);
  const me = self?.part_number || 1;
  return (summary?.parts || [])
    .filter((p) => p.id !== selfId && p.state === 'open' && SPLITTABLE_STATUSES.includes(p.status))
    .sort((a, b) => ((a.part_number < me) - (b.part_number < me)) || a.part_number - b.part_number)[0] || null;
};

/** Whole-PO tally for one product while batches are entered on one part. */
export const buildPoTally = ({ row, thisLines, entered, conv, selfState }) => {
  const mine = thisLines.reduce((a, l) => addM(a, lineMeasures(l)), [0, 0, 0]);
  const done = [row.dispatched, row.dispatched_cases, row.dispatched_kg];
  const open = [row.in_progress, row.in_progress_cases, row.in_progress_kg];
  const sent = fill(selfState === 'dispatched' ? subM(done, mine) : done, conv);
  const others = fill(selfState === 'dispatched' ? open : subM(open, mine), conv);
  const ordered = fill([row.ordered, row.ordered_cases, row.ordered_kg], conv);
  const short = fill([row.closed_short || 0, 0, 0], conv);
  const total = addM(addM(addM(sent, entered), others), short);
  return { ordered, sent, now: entered, others, short, total, carry: r3(mine[0] - entered[0]) };
};

export const pct = (value, target) => (target > 0 ? ((value - target) / target) * 100 : 0);

export const announceAdjustments = (toast, records = [], failed = false) => {
  if (failed) toast.error('Saved, but the next part of this PO could not be adjusted. Check the PO Summary.', { duration: 10000 });
  (records || []).forEach((r) => {
    const qty = fmtQty(Math.abs(r.units));
    if (r.to_dispatch_number) {
      toast.info(`${r.product_name}: Part ${r.to_part} (#${r.to_dispatch_number}) ${r.units > 0 ? `gets +${qty}` : `drops by ${qty}`} units (Part ${r.from_part} shipped ${r.kind === 'over' ? 'over' : 'short'})`, { duration: 8000 });
      if (r.emptied) toast.warning(`Part ${r.to_part} (#${r.to_dispatch_number}) has nothing left to send. Cancel it if it's no longer needed.`, { duration: 10000 });
    } else {
      toast.warning(`${r.product_name}: ${qty} units ${r.kind === 'over' ? 'over' : 'short'} on the PO. No open part left to adjust.`, { duration: 10000 });
    }
  });
};
